import { AgentAssignmentPoolOverview, Configuration, UpdateAgentAssignmentPoolRequest } from '@types'
import { client } from './client'

const getConfigurationsService = async (cocap: string) => {
  const { data } = await client.get('/configurations', {
    headers: {
      cocap
    }
  })
  return data
}

const updateConfigurationService = async (name: string, cocap: string, body: Partial<Configuration>) => {
  const { data } = await client.put(
    `/configurations/${name}`,
    {
      ...body
    },
    {
      headers: {
        cocap
      }
    }
  )
  return data
}

const getAgentAssignmentPoolOverviewService = async (cocap: string): Promise<AgentAssignmentPoolOverview> => {
  const { data } = await client.get('/agent-assignment-pool/admin-overview', {
    headers: {
      cocap
    }
  })
  return data
}

const updateAgentAssignmentPoolService = async (
  cocap: string,
  body: UpdateAgentAssignmentPoolRequest
): Promise<AgentAssignmentPoolOverview> => {
  const { data } = await client.put('/agent-assignment-pool/current', body, {
    headers: {
      cocap
    }
  })
  return data
}

export {
  getAgentAssignmentPoolOverviewService,
  getConfigurationsService,
  updateAgentAssignmentPoolService,
  updateConfigurationService
}
